// extracted by mini-css-extract-plugin
export default {"root":"IconTwint_root__ZSPdR"};